import { EditableField } from '@nemuru-eng/js-api-client';

import { FinancingField } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingField';

export const isEditFinancingEnabled = (editableFields: EditableField[]): boolean =>
  editableFields.includes(EditableField.PRINCIPAL) || editableFields.includes(EditableField.VEHICLE_AMOUNT);

export const isFinancingFieldEditable = (editableFields: EditableField[], field: FinancingField): boolean =>
  editableFields.includes(field);
